import axios, { AxiosResponse } from "axios";
import { con } from "../../../application/entity/Rutas";
import { IServiceResult } from "../../Interfaces/IServiceResult";
import { ServiceResult } from "./ServiceResult";

export class SVCCombos {
    public static async ObtieneComuna(codigoNegocio: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();

        const url: string = _ruta + "TerceraBase/comunaGetComuna";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        await axios
            .get(url)
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtieneGenero(): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();

        const url: string = _ruta + "TerceraBase/Sexo";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        await axios
            .get(url)
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    // public static async ObtieneEstadoCivil(codigoNegocio: number): Promise<IServiceResult<any>> {
    //     let _ruta: string = con.RetornaRuta();

    //     const url: string = _ruta + "EstadoCivil/getEstadoCivil";
    //     let sr: ServiceResult<any> = new ServiceResult<any>();
    //     sr.errorMessage = "Inicializando invocación";
    //     await axios
    //         .get(url,
    //             {
    //                 params: {
    //                     'codigoNegocio': codigoNegocio
    //                 }
    //             })
    //         .then((res: AxiosResponse) => {
    //             if (res.data !== undefined) {
    //                 sr.result = res.data;
    //             }
    //         })
    //         .catch((err: any) => {
    //             sr.errorMessage = "Error al leer";
    //             sr.errorDetails = err;
    //         });

    //     return sr;
    // }

    public static async ObtienePaisNacionalidad(codigoNegocio: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "TerceraBase/PaisNacionalidad";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        await axios
            .get(url)
                // ,
                // {
                //     params: {
                //         'codigoNegocio': codigoNegocio
                //     }
                // }
                // )
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }
    public static async ObtieneComunaHomologa(
        CodComuna: number,
        Comuna_Db_Finanzas:string,
        Cod_Comuna_Db_Docencia:number        
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();

        const url: string = _ruta + "TerceraBase/ComunaHomologa?CodComuna=" + CodComuna + 
        "&Cod_Comuna_Db_Docencia="+ Cod_Comuna_Db_Docencia +
        "&Comuna_Db_Finanzas=" + '' 
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        await axios
            .get(url)
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }
}